<template>
  <div>
    <video ref="videoPlayer" class="video-js" playsinline></video>
  </div>
</template>

<script>
import videojs from "../../node_modules/video.js";

export default {
  name: "VideoPlayer",
  props: {
    options: {
      controls: true,
      autoplay: false,
      preload: "auto",
      type: Object,
      default() {
        return {
          navigationUI: "hide",
        };
      },
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
        console.log("onPlayerReady", this);
      }
    );
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style scoped>
    .video-js .vjs-tech {
        width: 90%;
        height: 300px;
    }

     @media (max-width: 959px) {
           .video-js .vjs-tech {
        width: 100vw;
        height: 300px;
    }
     }
</style>